import {SuccessFillIcon} from '@prtimes-basis/icons';
import {FormStepIndicator} from '../../components/form-step-indicator';
import styles from './complete-step.module.css';

export function CompleteStep() {
  return (
    <div className={styles.container}>
      <h2 className={styles.h2}>PR TIMESに企業登録申請</h2>

      <FormStepIndicator step={3} />

      <div className={styles.description}>
        <SuccessFillIcon className={styles.icon} />

        <h1 className={styles.h1}>
          <span>申請が完了しました。</span>
          <span>ありがとうございました。</span>
        </h1>

        <p className={styles.detail}>
          <span>企業登録の審査を行わせて頂き、通常１営業日以内に、</span>
          <span>お申し込み完了をご通知するメールをお送りします。</span>
        </p>
      </div>

      <a href='/' className={styles.anchor}>
        トップへ戻る
      </a>
    </div>
  );
}
